import React, { useState } from "react";
import "./styles/Contact.css";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { addContactRequest } from "../api/ContactAPI";
import { Comment } from "react-loader-spinner";
import { useModal } from "../contexts/ModalContext";

const Contact = ({ contactSectionRef }) => {
  const { openModal } = useModal();

  const [isLoading, setisLoading] = useState(false);
  const [fName, setfName] = useState("");
  const [lName, setlName] = useState("");
  const [email, setemail] = useState("");
  const [request, setrequest] = useState("");

  // Intersect Observer ( Checks if component is in view )
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });

  const handleSubmit = (event) => {
    // event.preventDefault(); // Prevent page refresh
    // Call your function here
    createContactRequest();
  };

  async function createContactRequest() {
    setisLoading(true);
    const requestProps = {
      fName: fName,
      lName: lName,
      email: email,
      request: request,
    };
    // Call your API function here
    const res = await addContactRequest(requestProps);
    if (res.success) {
      openModal("alert", {
        alertProps: { type: 2, message: "Request sent successfully!" },
      });
      setfName("");
      setlName("");
      setemail("");
      setrequest("");
    } else {
      openModal("alert", {
        alertProps: { type: 0, message: "Request error, please try again." },
      });
    }
    setisLoading(false);
  }

  return (
    <div className="contact-section" ref={contactSectionRef}>
      <motion.div
        ref={ref}
        initial={{ opacity: 0, scale: 0.95 }}
        animate={inView ? { opacity: 1, scale: 1 } : {}}
        transition={{ duration: 0.3, ease: "easeOut" }}
        className="contact-motion-container"
      >
        <div className="container">
          <h2>Contact Us</h2>
          <form action={handleSubmit} className="contact-form">
            <div>
              <input
                onChange={(e) => setfName(e.target.value)}
                value={fName}
                type="text"
                placeholder="First Name"
                required
              />
              <input
                onChange={(e) => setlName(e.target.value)}
                value={lName}
                type="text"
                placeholder="Last Name"
                required
              />
            </div>
            <input
              onChange={(e) => setemail(e.target.value)}
              value={email}
              type="email"
              placeholder="Email"
              required
            />
            <textarea
              onChange={(e) => setrequest(e.target.value)}
              value={request}
              placeholder="Please type your questions, concerns or ideas, and we will get back to you ASAP."
              rows="4"
              required
            ></textarea>
            <button type="submit">
              {isLoading ? (
                <Comment
                  visible={true}
                  height="42"
                  width="42"
                  ariaLabel="comment-loading"
                  wrapperStyle={{}}
                  wrapperClass="comment-wrapper"
                  color="var(--color-primary)"
                  backgroundColor="#ffffff"
                />
              ) : (
                "Submit"
              )}
            </button>
          </form>
        </div>
      </motion.div>
    </div>
  );
};

export default Contact;
